import React, {useState, useEffect, useRef, useReducer} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {verifyUser} from "../authRequests";
import {patientReducer, init} from "../additional_files/reducer";
import Layout from "../components/Layout";
import FormsStatus from "../components/FormsStatus";
import {Box, VStack, Heading, Text} from "@chakra-ui/react";

export default function Forms() {
  const navigate = useNavigate();
  const loadedRef = useRef(null);
  const {state} = useLocation();
  const [dashState, dispatch] = useReducer(patientReducer, state, init);
  const sessionStart = useRef(true);

  useEffect(function () {
    verifyUser(state ? state.jwt : "", loadedRef);
  }, []);

  useEffect(() => {
    if (!sessionStart.current) {
      dispatch({type: "UPDATE_STATE", payload: state});
    }
  }, [state, dispatch]);

  useEffect(() => {
    sessionStart.current = false;
  }, []);

  return (
    <Layout state={{...dashState}} dispatch={dispatch}>
      <VStack
        ref={loadedRef}
        style={{opacity: 0}}
        flex={1}
        w="100%"
        overflow="auto"
        align="stretch"
      >
        <Box w="100%" flex={1} px={{base: 4, md: 6}} py={5} display="flex" flexDirection="column">
          <Box mb={4}>
            <Heading fontSize="xl" fontWeight="600" color="#1a1f36">
              Forms
            </Heading>
            <Text fontSize="13px" color="#6b7280" mt={1}>
              Complete assigned forms and review your submissions
            </Text>
          </Box>
          <FormsStatus state={dashState} />
        </Box>
      </VStack>
    </Layout>
  );
}
